<template>
  <v-dialog v-if="value" v-model="localDialog" max-width="100%">
    <v-card flat loader-height="10" tile>
      <v-toolbar class="justify-content-center" color="secondary" height="40" max-height="40">
        <v-toolbar-title v-text="$t('send_wa')" />
      </v-toolbar>
      <v-card-text>
        <div class="pt-2">
          <app-row class="ma-0 pa-0" dense>
            <v-col class="ma-0 pa-0" dense md="12" sm="12">
              <app-row class="ma-0 pa-0" dense>
                <v-col class="ma-0 pa-0 pt-3" dense md="12" sm="12">
                  <v-autocomplete
                    :value="selectedTemplate"
                    :items="templates"
                    :label="$t('select_wa_template')"
                    clearable
                    dense
                    item-text="name_ar"
                    item-value="id"
                    outlined
                    return-object
                    @change="handleTemplateChange"
                  />
                </v-col>
              </app-row>
              <app-row class="ma-0 pa-0" dense>
                <v-col class="ma-0 pa-0 pt-2" dense md="12" sm="12">
                  <app-textarea-input
                    :value="messageBody"
                    name="message_body"
                    :counter="false"
                    autocomplete="off"
                    class="ma-0 pa-0"
                    clearable
                    dense
                    label="message_body"
                    rows="5"
                    @input="updateMessageBody"
                  />
                </v-col>
              </app-row>
              <app-row class="ma-0 pa-0" dense>
                <v-col class="ma-0 pa-0" md="3" sm="6">
                  {{ $tc('choice.Claims', 2) }}: {{ selectedCount }}
                </v-col>
                <v-col class="ma-0 pa-0" md="3" sm="6"></v-col>
                <v-col class="ma-0 pa-0" md="3" sm="6"></v-col>
                <v-col class="ma-0 pa-0" md="3" sm="6"></v-col>
              </app-row>
            </v-col>
          </app-row>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <app-btn :loading="loading" class="mt-2" md="4" sm="6" @click="$emit('send')">
          {{ $t('send_wa') }}
        </app-btn>
        <app-btn :loading="loading" color="error" min-width="120" tooltip="close_window" @click="handleClose">
          {{ $t('close') }}
        </app-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WaSendDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    templates: {
      type: Array,
      default: () => [],
    },
    selectedTemplate: {
      type: [Object, null],
      default: null,
    },
    messageBody: {
      type: String,
      default: '',
    },
    selectedCount: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    localDialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    handleTemplateChange(template) {
      this.$emit('update:selectedTemplate', template);
      this.$emit('template-change', template);
    },
    updateMessageBody(value) {
      this.$emit('update:messageBody', value);
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>
